'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
        .state('dashboard.departments.department.forms.form.builder', {
            url: '/builder?:copy:oldDepartmentId:oldFormId:update:fieldToArchive:selectedTab',
            templateUrl: 'dashboard-builder/dashboard-builder.html',
            controller: 'dashboardBuilderCtrl as ctrl',
            resolve: {
                Form: ['Form', 'Department', '$stateParams', 'FormFactory', 'toast', 'Authentication', "$translate", function (Forms, Department, $stateParams, FormFactory, toast, Authentication, $translate) {
                    if (Authentication.isAuthorized('supervisor')) {
                        console.log('No autorizado')
                        // toast.errorNoTimeout($translate.instant("DASHBOARD.NO_AUTHORIZED"));
                    }
                    if ($stateParams.formId === 'new') {
                        return FormFactory.newForm($stateParams.departmentId);
                    }
                    return Forms.find({
                        filter: {
                            "where": {
                                "id": ($stateParams.copy ? $stateParams.oldFormId : $stateParams.formId)
                            },
                            "include": {
                                "relation": "items",
                                "scope": {
                                    "limit": 1
                                }
                            }
                        }
                    })
                        .$promise
                        .then(function (form) {
                            form = form[0];
                            if ($stateParams.copy) {
                                delete form.id;
                                delete form.departmentId;
                                if ($stateParams.update != 'new' && $stateParams.formId) {
                                    form.id = $stateParams.formId
                                    form.departmentId = $stateParams.departmentId
                                }
                                //delete form.tenantId;
                                delete form.$promise;
                                delete form.$resolved;
                                if ($stateParams.update != 'new') {
                                    return Forms.find({
                                        filter: {
                                            "where": {
                                                "id": ($stateParams.formId)
                                            }
                                        }
                                    })
                                        .$promise
                                        .then(function (formOld) {
                                            formOld = formOld[0];
                                            form.name = formOld.name;
                                            form.description = formOld.description;
                                            form.validate_required = formOld.validate_required;
                                            if ($stateParams.update == 'update' && $stateParams.fieldToArchive) {
                                                if(!Array.isArray($stateParams.fieldToArchive))
                                                    $stateParams.fieldToArchive=[$stateParams.fieldToArchive];
                                                formOld.pages.forEach(function (page, pageIdx) {
                                                    page.fields.forEach(function (elS) {
                                                        let idxD = $stateParams.fieldToArchive.findIndex(function (elId) { return elId == elS.id })
                                                        if (idxD != -1) {
                                                            elS.isArchived = true;
                                                            let idxP = pageIdx;
                                                            if (!form.pages[idxP]) {
                                                                idxP = form.pages.findIndex(function (el) { return el.id == page.id })
                                                                if (idxP == -1) {
                                                                    idxP = form.pages.length;
                                                                    form.pages.push({ id: page.id, type: 'page', fields: [] });
                                                                }
                                                            }
                                                            form.pages[idxP].fields.push(elS);
                                                        }
                                                    });
                                                });
                                            }
                                            return FormFactory.loadForm(form);
                                        });

                                } else {
                                    return FormFactory.loadForm(form);
                                }
                            } else {
                                return FormFactory.loadForm(form);
                            }
                        });
                }],
                reportConfig: ['ReportConfig', '$stateParams', 'BuilderDataService', function(ReportConfig, $stateParams, BuilderDataService) {
                    if($stateParams.formId === 'new')
                        return BuilderDataService.getReportConfigInit();
                    return ReportConfig.find({ filter: { where: {formId: $stateParams.formId }}})
                        .$promise
                        .then(function(reportConfig) {
                            // console.log('ReportConfig 1')
                            if (reportConfig.length > 0) {
                                // console.log('ReportConfig 1.1 en if');
                                return reportConfig[0];
                            } else {
                                const reportConfig = BuilderDataService.getReportConfigInit();
                                // console.log('ReportConfig 1.1 en else', reportConfig);
                                return reportConfig;
                            }
                        });
                }],
                seletedTab: ['$stateParams', function($stateParams) {
                    if ($stateParams.selectedTab === '0') {
                        return '0';
                    } else {
                        return null
                    }
                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser']
            }
        });
};
